module.exports = __webpack_public_path__ + "img/staff.b61588cc.png";